import { Component, OnInit, OnDestroy } from '@angular/core';
import { SelectCurrentSiteApproval, SelectCurrentSiteApprovalId } from 'src/app/app-store/site-request/site-request.selector';
import { select, Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { ISiteRequestDetails } from 'src/app/feature/site-rediness-matrix/models/request';
import { LoginType } from 'src/app/helper/constants';
import { IRequestApproval } from '../../models/approvals';
import { RequestStatus } from 'src/app/feature/site-rediness-matrix/constants/constants';
import { userDetailsPayload } from 'src/app/app-store/user/user.selector';
import { IPayload } from 'src/app/models/user';
import * as moment from 'moment';
import { SiterequestService } from 'src/app/core/services/siterequest.service';
import { MatDialog } from '@angular/material/dialog';
import { InfoDialogueComponent } from 'src/app/shared/dialogues/infodialog/infodialog.component';
import { TranslocoService } from '@ngneat/transloco';
import { RejectConfirmationComponent, IRejectApproveConfirmationDialogData } from '../../dialogs/reject-confirmation/reject-confirmation.component';
import { Router } from '@angular/router';
import { GraphService } from 'src/app/core/services/graph.service';
import { DomSanitizer } from '@angular/platform-browser';
import { CrewdetailsdialogComponent } from 'src/app/feature/site-rediness-matrix/dialog/crewdetailsdialog/crewdetailsdialog.component';
import { LoginTypeSelector } from 'src/app/app-store/login/login.selector';
import { MapService } from 'src/app/core/services/map.service';


@Component({
  selector: 'app-site-request-details',
  templateUrl: './site-request-details.component.html',
  styleUrls: ['./site-request-details.component.css']
})
export class SiteRequestDetailsComponent implements OnInit, OnDestroy {
  approval: ISiteRequestDetails;
  show: boolean;
  userDetails: IPayload;
  requestDetailsSubscription: Subscription;
  userDetailsSubscription: Subscription;
  userImage: any;
  isProxySiteRequest: boolean;
  crewCount: number;
  LoginTypeSubscription: Subscription;
  userPhotoSubscription: Subscription;
  siteApprovalNumberSubscription: Subscription;

  constructor(
    private store: Store,
    private router: Router,
    private siteRequestService: SiterequestService,
    private dialog: MatDialog,
    private graphService: GraphService,
    private mapService: MapService,
    private sanitizer: DomSanitizer,
    private translocoService: TranslocoService) { }

  ngOnInit(): void {
    this.siteApprovalNumberSubscription = this.store.pipe(select(SelectCurrentSiteApprovalId)).subscribe(response => {
      this.mapService.setToolbarTitle('RQ ID - ' + response);
    });
    this.userImage = 'assets/icons/no_profile.png';
    this.requestDetailsSubscription = this.store.pipe(select(SelectCurrentSiteApproval)).subscribe(response => {
      if (response !== undefined) {
        this.approval = response;
        this.crewCount = this.approval?.siteRequestProxyMembers.length;
        this.isProxySiteRequest = this.approval.siteRequestProxyMembers.length !== 0;
      } else {
        this.router.navigateByUrl('/approvals');
      }
    });
    this.LoginTypeSubscription = this.store.pipe(select(LoginTypeSelector)).subscribe(response => {
      if (response === LoginType.Internal_User) {
        this.userPhotoSubscription = this.graphService.getUserPhoto(this.approval?.email).subscribe(blobResponse => {
          const objectURL = URL.createObjectURL(blobResponse);
          this.userImage = this.sanitizer.bypassSecurityTrustUrl(objectURL);
        });
      }
    });
    this.userDetailsSubscription = this.store.pipe(select(userDetailsPayload)).subscribe(response => {
      this.userDetails = response;
    });
  }

  openCrewDetailDialog(data) {
    this.dialog.open(CrewdetailsdialogComponent, {
      width: '500px',
      maxHeight:'80vh',
      disableClose: true,
      panelClass: 'custom-dialog-container',
      data
    });

  }

  onReject() {
    const data: IRejectApproveConfirmationDialogData = { isApproval: false, isBulk: false };
    const dialogRef = this.dialog.open(RejectConfirmationComponent, {
      disableClose: true,
      data
    });
    dialogRef.afterClosed().subscribe(response => {
      if (response.value) {
        this.onApproveOrReject(false, response.comment);
      }
    });
  }

  onApprove() {
    const data: IRejectApproveConfirmationDialogData = { isApproval: true, isBulk: false };
    const dialogRef = this.dialog.open(RejectConfirmationComponent, {
      disableClose: true,
      data
    });
    dialogRef.afterClosed().subscribe(response => {
      if (response.value) {
        this.onApproveOrReject(true, response.comment);
      }
    });
  }

  onApproveOrReject(isApproved: boolean, comment?: string) {
    this.show = true;
    const obj: IRequestApproval = {
      actionDetails: [{
        siteRequestId: this.approval.id,
        statusId: isApproved ? RequestStatus.Approved : RequestStatus.Rejected,
        comment: comment ? comment : null
      }],
      actionTakenByAlias: this.userDetails.alias,
      actionTakenByGin: this.userDetails.gin,
      actionTakenByEmail: this.userDetails.email,
      actionTakenOn: moment(new Date()).format('YYYY-MM-DDTHH:mm:ss'),
      actionTakenOnUtc: moment(new Date()).toISOString()
    };
    this.postApiDetails(obj, isApproved);
  }

  postApiDetails(obj: IRequestApproval, isApproved: boolean) {
    this.siteRequestService.postSiteRequestApproval(obj).subscribe(response => {
      this.show = false;
      if (response.message === undefined && response?.payload === undefined) {
        const dialogRef = this.dialog.open(InfoDialogueComponent, {
          disableClose: true,
          data: {
            status: isApproved
              ? this.translocoService.translate('request_approved_successfully')
              : this.translocoService.translate('request_rejected_successfully')
          }
        });
        dialogRef.afterClosed().subscribe(res => {
          this.router.navigateByUrl('/approvals', { replaceUrl: true });
        });
      } else if (response.message !== undefined && response?.payload === undefined) {
        this.dialog.open(InfoDialogueComponent, {
          disableClose: true,
          data: { status: response.message }
        });
      } else if (response.message !== undefined && response?.payload !== undefined) {
        this.dialog.open(InfoDialogueComponent, {
          disableClose: true,
          data: { status: response?.payload[0]?.message }
        });
      }
    },
      error => {
        this.show = false;
        this.dialog.open(InfoDialogueComponent, {
          disableClose: true,
          data: { status: this.translocoService.translate('something_wrong') }
        });
      });
  }

  ngOnDestroy() {
    if (this.requestDetailsSubscription) {
      this.requestDetailsSubscription.unsubscribe();
    }
    if (this.LoginTypeSubscription) {
      this.LoginTypeSubscription.unsubscribe();
    }
    if (this.userPhotoSubscription) {
      this.userPhotoSubscription.unsubscribe();
    }
    if (this.siteApprovalNumberSubscription) {
      this.siteApprovalNumberSubscription.unsubscribe();
    }
  }

}
